import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            {/* Brand */}
            <div className="md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                  <i className="ri-fire-fill text-lg text-background-50"></i>
                </div>
                <span className="font-heading text-xl font-bold whitespace-nowrap">
                  爆料网
                </span>
              </Link>
              <p className="text-sm text-secondary-300 leading-relaxed">
                网红爆料·娱乐爆料·八卦爆料综合平台，每日更新最新网红吃瓜、黑料、八卦汇总，新鲜瓜料一网打尽。
              </p>
            </div>

            {/* Categories */}
            <div>
              <h4 className="font-heading text-base font-bold mb-4">
                <Link to="/" className="hover:text-primary-400 transition-colors">
                  热门分类
                </Link>
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-secondary-300 hover:text-background-50 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-heading text-base font-bold mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/wanghong-xiangliao" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                    最新爆料
                  </Link>
                </li>
                <li>
                  <Link to="/category/wanghong-chigua" className="text-sm text-secondary-300 hover:text-background-50 transition-colors">
                    网红吃瓜
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-heading text-base font-bold mb-4">联系我们</h4>
              <ul className="space-y-2.5 text-sm text-secondary-300">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>contact@baoliaowang.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-wechat-line"></i>
                  <span>微信公众号：爆料网</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-weibo-line"></i>
                  <span>微博：@爆料网官方</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-400">
              &copy; 2026 爆料网 BaoliaoWang.com - 版权所有
            </p>
            <div className="flex items-center gap-4 text-xs text-secondary-400">
              <a href="#" className="hover:text-background-50 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-background-50 transition-colors">用户协议</a>
              <a href="#" className="hover:text-background-50 transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}